import { Validator } from '@vista-digital/validator';
import { captchaFieldDisplayTextValidator, defaultCaptchaFieldDisplayText } from '../../../subcomponents/form/field/captcha/types/display-text';
import { defaultCurrentPasswordFieldDisplayText } from '../../../subcomponents/form/field/current-password/types/display-text';
import { inputFieldDisplayTextValidator } from '../../../subcomponents/form/field/input/types/display-text';
import { passwordFieldDisplayTextValidator } from '../../../subcomponents/form/field/password/types/display-text';
import { InvalidFieldNameError } from '../../../types/invalid-field-name-error';
import { defaultUpdateMemberPasswordFormPasswordFieldDisplayText } from './display-text';
import { UpdateMemberPasswordFormFieldName } from './name';
const updateMemberPasswordFormCurrentPasswordFieldPropsValidator = Validator.object({
    name: Validator.isEqualTo(UpdateMemberPasswordFormFieldName.CurrentPassword),
    displayText: inputFieldDisplayTextValidator
});
const updateMemberPasswordFormPasswordFieldPropsValidator = Validator.object({
    name: Validator.isEqualTo(UpdateMemberPasswordFormFieldName.Password),
    displayText: passwordFieldDisplayTextValidator
});
const updateMemberPasswordFormCaptchaFieldPropsValidator = Validator.object({
    name: Validator.isEqualTo(UpdateMemberPasswordFormFieldName.Captcha),
    displayText: captchaFieldDisplayTextValidator
});
export const updateMemberPasswordFormFieldPropsValidator = Validator.any([
    updateMemberPasswordFormCurrentPasswordFieldPropsValidator,
    updateMemberPasswordFormPasswordFieldPropsValidator,
    updateMemberPasswordFormCaptchaFieldPropsValidator
]);
const defaultPasswordFieldProps = {
    name: UpdateMemberPasswordFormFieldName.Password,
    displayText: defaultUpdateMemberPasswordFormPasswordFieldDisplayText
};
const defaultCurrentPasswordFieldProps = {
    name: UpdateMemberPasswordFormFieldName.CurrentPassword,
    displayText: defaultCurrentPasswordFieldDisplayText
};
const defaultCaptchaFieldProps = {
    name: UpdateMemberPasswordFormFieldName.Captcha,
    displayText: defaultCaptchaFieldDisplayText
};
export const defaultUpdateMemberPasswordFormFieldPropsProvider = props => {
    switch (props.name) {
        case UpdateMemberPasswordFormFieldName.Password:
            return defaultPasswordFieldProps;
        case UpdateMemberPasswordFormFieldName.CurrentPassword:
            return defaultCurrentPasswordFieldProps;
        case UpdateMemberPasswordFormFieldName.Captcha:
            return defaultCaptchaFieldProps;
        default:
            throw new InvalidFieldNameError('UpdateMemberPasswordFormField', props.name);
    }
};
